import {useParams} from 'react-router-dom';
import GlobalCurriculumTable from "../../pages/common/globalcurriculumtable";
import Student12TopMenu from "../studentInfo/student12topmenu"
import { useAuth } from "../../../usercontext";
import PageNotes from "../../pages/common/pagenotesnew";

export default function InstructorCurriculumTable() {

  const { profile, setProfile } = useAuth();
  let { slug } = useParams();

  return (
            <>
             <Student12TopMenu slug={slug} activeMenu={"Timeline"} />
              <div className="tak-instruct-group">
                <div className="row">
                  <div className="col-md-12">
                  <PageNotes
              type={"Instructor"}
              pageName={"Timeline"}
              studentId={slug}
              instructorId={profile.id}
            />
                    <GlobalCurriculumTable slug={slug}/>
                  </div>
                </div>
              </div>
            </>
  );
}
